import React from 'react'
import WidgetGrid from './Component/WidgetGrid/index'

export default _ => <WidgetGrid dashboard="home"/>





// WEBPACK FOOTER //
// ./app/App/Module/Home/index.js